/*
格式化金额
*/
/*
function formatMoney(s, n = 2, decPoint = ',',thousandsSep = '.'){
    var s = round(s,n);
    if(s < 0){
        var s_bak = s;
        var s = -s;
    }
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    var l = s.split(".")[0].split("").reverse(),
    r = s.split(".")[1];
    var t = "";
    var i = 0
    for(i = 0; i < l.length; i ++ )
    {
       t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? thousandsSep : "");
    }
    if(s_bak < 0){
        return '-' + t.split("").reverse().join("") + decPoint + r;
    }else{
        return t.split("").reverse().join("") + decPoint + r;
    }
 }
 */
function formatMoney(num, digits = 2, decimalSeparator = '.', thousandSeparator = ',', removeTrailingZeros = false) {
  // 检查 num 是否是一个数字
  if (typeof num !== 'number') {
    var num = parseFloat(num);
  }
  // 四舍五入到指定的小数位数
  let result = num.toFixed(digits);

  // 替换小数点
  result = result.replace('.', decimalSeparator);

  // 添加千分位分隔符
  let regex = new RegExp(`\\B(?=(\\d{3})+(?!\\d))`, 'g');
  result = result.replace(regex, thousandSeparator);

  // 如果没有小数位并且 removeTrailingZeros 为 true，去掉小数点
  if (removeTrailingZeros) {
    let decimalPart = decimalSeparator + '0'.repeat(digits);
    result = result.endsWith(decimalPart) ? result.slice(0, -digits-1) : result;
  }

  return result;
}
 /*
 格式化时间
 */
 function formatDate(timestamp,format_type = 0) {
    if (timestamp.toString().length === 13) {
        timestamp = parseInt(timestamp.toString().substring(0, 10)); // 截取前 10 位并转换为数字
    }
    var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM;
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    switch (format_type) {
        case 1:
            return d + '/' + MM + '/' + y + ' ' + h + ':' + m;
            break;
        case 2:
            return d + '/' + MM + '/' + y;
            break;
        default:
            return d + '/' + MM + '/' + y + ' ' + h + ':' + m + ':' + s;
            break;
    }
}
/**
 数字补全
 */
function PrefixInteger(num, m) {
    return (Array(m).join(0) + num).slice(-m);
}
 /**
 * 四舍五入
 * @param  {[type]} num     [待处理数字]
 * @param  {[type]} decimal [需要保留的小数位]
 * @return {[type]}         []
 */
function round(num, dig = 2) {
    var times = Math.pow(10, parseInt(dig));
    var big_float = parseFloat(num) * times;
    /* 考虑负数 */
    var big_int = (big_float >= 0)? Math.round(big_float): Math.round(-1 * big_float) * -1;
    var res = big_int / times;
    return res;
}

function dealWithTime(data) {
    let formatDateTime;
    let Y = data.getFullYear();
    let M = PrefixInteger(data.getMonth() + 1,2);
    let D = PrefixInteger(data.getDate(),2);
    let H = data.getHours();
    let Min = data.getMinutes();
    let S = data.getSeconds();
    let W = data.getDay();
    H = H < 10 ? "0" + H : H;
    Min = Min < 10 ? "0" + Min : Min;
    S = S < 10 ? "0" + S : S;
    switch (W) {
        case 0:
        W = "Domingo";
        break;
        case 1:
        W = "Lunes";
        break;
        case 2:
        W = "Martes";
        break;
        case 3:
        W = "Miércoles";
        break;
        case 4:
        W = "Jueves";
        break;
        case 5:
        W = "Viernes";
        break;
        case 6:
        W = "Sábado";
        break;
        default:
        break;
    }
    return W + ' ' +  D + "/" + M + "/" + Y + " " +  H + ":" + Min + ":" + S;
}
function timestamp(now = 1, time = '') {
    if(time){
        var date = new Date(time)
    }else{
        var date = new Date()
    }
    
    if(now == 0){
        date.setHours(0, 0, 0, 0)
    }else if(now == 2){
        date.setHours(23, 59, 59, 999)
    }
    var timestamp = date.getTime()
    if(toString(timestamp).length > 15){
      var timestamp = timestamp/1000
    }
    return parseInt(timestamp);
}
function is_numeric(obj){
    var reg;
    if(/^[\d]+$/.test(obj)){
        return true;
    }else{
        return false;
    }
}

/* eslint-disable no-unsafe-finally */
/* eslint-disable no-useless-catch */
/* eslint-disable no-empty */
var countDecimals = function(num) {    
    var len = 0;    
    try {        
        num = Number(num);        
        var str = num.toString().toUpperCase();        
        if (str.split('E').length === 2) {             
            var isDecimal = false;            
            if (str.split('.').length === 2) {                
                str = str.split('.')[1];                
                if (parseInt(str.split('E')[0]) !== 0) {                    
                    isDecimal = true;                
                }            
            }            
            let x = str.split('E');            
            if (isDecimal) {                
                len = x[0].length;            
            }            
            len -= parseInt(x[1]);        
        } else if (str.split('.').length === 2) {           
            if (parseInt(str.split('.')[1]) !== 0) {                
                len = str.split('.')[1].length;            
            }        
        }    
    } catch (e) {        
        throw e;    
    } finally {        
        if (isNaN(len) || len < 0) {            
            len = 0;        
        }        
        return len;    
    }
}; 
var convertToInt = function(num) {    
    num = Number(num);    
    var newNum = num;    
    var times = countDecimals(num);    
    var temp_num = num.toString().toUpperCase();    
    if (temp_num.split('E').length === 2) {        
        newNum = Math.round(num * Math.pow(10, times));    
    } else {        
        newNum = Number(temp_num.replace(".", ""));    
    }    
    return newNum;
}; 
var getCorrectResult = function(type, num1, num2, result) {    
    var temp_result = 0;    
    switch (type) {        
        case "add":            
            temp_result = num1 + num2;            
            break;        
        case "sub":            
            temp_result = num1 - num2;            
            break;        
        case "div":            
            temp_result = num1 / num2;            
            break;        
        case "mul":            
            temp_result = num1 * num2;            
            break;    
    }    
    if (Math.abs(result - temp_result) > 1) {        
        return temp_result;    
    }    
    return result;
};
//加法    
function accAdd(num1, num2) {        
    num1 = Number(num1);        
    num2 = Number(num2);        
    var dec1, dec2, times;        
    try { dec1 = countDecimals(num1) + 1; } catch (e) { dec1 = 0; }        
    try { dec2 = countDecimals(num2) + 1; } catch (e) { dec2 = 0; }        
    times = Math.pow(10, Math.max(dec1, dec2));        
    var result = (this.accMul(num1, times) + this.accMul(num2, times)) / times;        
    return getCorrectResult("add", num1, num2, result);    
}
//减法    
function accSub(num1, num2) {        
    num1 = Number(num1);        
    num2 = Number(num2);        
    var dec1, dec2, times;        
    try { dec1 = countDecimals(num1) + 1; } catch (e) { dec1 = 0; }        
    try { dec2 = countDecimals(num2) + 1; } catch (e) { dec2 = 0; }        
    times = Math.pow(10, Math.max(dec1, dec2));        
    var result = Number((this.accMul(num1, times) - this.accMul(num2, times)) / times);        
    return getCorrectResult("sub", num1, num2, result);    
}
//除法    
function accDiv(num1, num2) {        
    num1 = Number(num1);        
    num2 = Number(num2);        
    var t1 = 0,            
        t2 = 0,            
        dec1, dec2;        
    try { t1 = countDecimals(num1); } catch (e) {}        
    try { t2 = countDecimals(num2); } catch (e) {}        
    dec1 = convertToInt(num1);        
    dec2 = convertToInt(num2);        
    var result = this.accMul((dec1 / dec2), Math.pow(10, t2 - t1));        
    return getCorrectResult("div", num1, num2, result);    
}
//乘法    
function accMul(num1, num2) {        
    num1 = Number(num1);        
    num2 = Number(num2);        
    var times = 0,            
        s1 = num1.toString(),            
        s2 = num2.toString();        
    try { times += countDecimals(s1); } catch (e) {}        
    try { times += countDecimals(s2); } catch (e) {}        
    var result = convertToInt(s1) * convertToInt(s2) / Math.pow(10, times);        
    return getCorrectResult("mul", num1, num2, result);    
}
//表示根据number属性降序排列;若第二个参数不传递，默认表示升序排序
/*
@param attr 排序的属性 如number属性
@param rev true表示升序排列，false降序排序
*/
function sortBy(attr,rev){
    //第二个参数没有传递 默认升序排列
    if(rev ==  undefined){
        rev = 1;
    }else{
        rev = (rev) ? 1 : -1;
    }
    
    return function(a,b){
        a = a[attr];
        b = b[attr];
        if(a < b){
            return rev * -1;
        }
        if(a > b){
            return rev * 1;
        }
        return 0;
    }
}
export default{
    dealWithTime,
    formatMoney,
    formatDate,
    is_numeric,
    round,
    accAdd,
    accSub,
    accDiv,
    accMul,
    sortBy,
    PrefixInteger,
    timestamp
}


// WEBPACK FOOTER //
// ./src/plugins/fun.js